import { render } from "./entrepreneurshipMentorDetail.vue?vue&type=template&id=465728a6&scoped=true"
import script from "./entrepreneurshipMentorDetail.vue?vue&type=script&lang=js"
export * from "./entrepreneurshipMentorDetail.vue?vue&type=script&lang=js"

import "./entrepreneurshipMentorDetail.vue?vue&type=style&index=0&id=465728a6&lang=less&scoped=true"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-465728a6"]])

export default __exports__